import { XMarkIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
import { toast } from "react-hot-toast";

const WorkorderToast = ({ workorderId, workorderRef }: { workorderId: string; workorderRef: string }) => {
  const handleDismiss = () => {
    toast.dismiss();
  };

  const handleRedirect = () => {
    toast.dismiss();
    window.history.pushState({}, "", `/workorders/${workorderId}`);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <p>{t("workorder:notifications:create:success", { ref: workorderRef }).split("</br>")[0]}</p>
        <XMarkIcon className="w-4 h-4 cursor-pointer" onClick={handleDismiss} />
      </div>
      <div>
        <button
          onClick={handleRedirect}
          style={{ color: "#065F46", fontWeight: "bold", cursor: "pointer", background: "none", border: "none" }}
        >
          {t("workorder:notifications:create:action")} {workorderRef}
        </button>
      </div>
    </div>
  );
};

const showWorkorderToast = (workorderId: string, workorderRef: string) => {
  toast.success(
    <WorkorderToast workorderId={workorderId} workorderRef={workorderRef} />,
    {
      duration: Infinity
    }
  );
};

export { showWorkorderToast };